// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable no-prototype-builtins */
import { executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    GetUnfilteredProducts,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

export const XngPopulateApiParameter: any = (props: any) => {
    const filters = props.result.productFilters;

    const {
        query,
        brandIds,
        productLineIds,
        priceFilters,
        attributeValueIds,
        searchWithinQueries,
        pageCategoryId,
        pageBrandId,
        pageProductLineId,
        ...apiParameter
    } = filters;
    props.apiParameter = {
        ...apiParameter,
        search: query,
        categoryId: filters.categoryId || filters.pageCategoryId,
        searchWithin: searchWithinQueries?.join(" "),
        includeSuggestions: filters.includeSuggestions !== false,
        brandIds: filters.pageBrandId && !brandIds ? [filters.pageBrandId] : brandIds,
        productLineIds: filters.pageProductLineId ? [filters.pageProductLineId] : productLineIds,
        priceFilters,
        attributeValueIds,
        expand: props.expandTokens || [],
        applyPersonalization: true,
        includeAttributes: ["includeOnProduct"],
        includeProductsInSubCategories: !!(
            filters.categoryId?.length ||
            filters.pageCategoryId?.length ||
            props.result.catelogPage?.categoryId.length
        ),
    };

    // XNG-896: add restrictAttributesToCategory to product api for L2  categories
    const categoryId =
        filters?.pageBrandId?.length > 0
            ? `${props.apiParameter.categoryId}:${filters.pageBrandId}`
            : props.apiParameter.categoryId;
    const category = getCategoryState(props.getState(), categoryId).value;
    const restrictAttributesToCategory = props.parameter?.["restrictAttributesToCategory"];
    if (
        props.apiParameter?.categoryId &&
        (category?.properties?.isLevelOneCategory === "false" || !category?.properties?.isLevelOneCategory)
    ) {
        props.apiParameter = {
            ...props.apiParameter,
            restrictAttributesToCategory,
        };
    }
};

export const XngGetUnfilteredProducts: any = async (props: any) => {
    const unfilteredApiParameter = { ...props.apiParameter };
    delete unfilteredApiParameter.searchWithin;
    if (!props.result.productFilters.pageBrandId) {
        delete unfilteredApiParameter.brandIds;
    }
    if (!props.result.productFilters.pageProductLineId) {
        delete unfilteredApiParameter.productLineIds;
    }
    delete unfilteredApiParameter.priceFilters;
    delete unfilteredApiParameter.attributeValueIds;
    if (
        !props.result.productFilters.pageCategoryId &&
        !unfilteredApiParameter?.hasOwnProperty("includeProductsInSubCategories")
    ) {
        delete unfilteredApiParameter.categoryId;
    }
    unfilteredApiParameter.stockedItemsOnly = undefined;
    unfilteredApiParameter.previouslyPurchasedProducts = undefined;

    props.result.unfilteredApiParameter = unfilteredApiParameter;
    props.result.filteredApiParameter = { ...props.apiParameter };

    const unfilteredProducts = getProductsDataView(props.getState(), unfilteredApiParameter).value;

    if (unfilteredProducts) {
        return;
    }

    await executeAwaitableHandlerChain(loadProducts, unfilteredApiParameter, props);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
